import React from 'react';
import Testimonial from '../../evaluations/Testimonial';
import useDialogLauncher from '../../../../hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '../../../dialogs_new/DialogManager';

export default function Evaluation(props) {
  const { evaluation } = props;

  const launch = useDialogLauncher();

  function onClick() {
    launch(DialogManager.EvaluationProjectEducator.Config(evaluation.id));
  }

  return (
    <Testimonial
      evaluation={evaluation}
      onClick={onClick}
    />
  );
}
